<template>
  <div class="user-main invoice-detail-page">
    <div class="user-main-head detail-page-head">
      <img data-track-text="返回订单列表" @click="clickHandler('/order')" style="margin-left: 28px" src="../assets/go-back.png" alt=""/>
      <div>发票详情</div>
    </div>
    <div class="detail-page-body" style="width: 100%;background: #FFFFFF;display: flex;justify-content: center">
      <div class="main-login-form">
        <div class="main-login-form-input">
          <div style="display: flex;height: 90px;align-items: center;">
            <div style="width: 150px;font-size: 24px;font-family: Adobe Heiti Std;font-weight: normal;color: #666666;">
              开票编号
            </div>
            <div style="font-size: 24px;font-family: Adobe Heiti Std;font-weight: normal;color: #333333;">
              {{ item.billCode }}
            </div>
          </div>
          <div style="width: 704px;height: 2px;background: #DDDDDD;"></div>
          <div style="display: flex;min-height: 90px;align-items: center;">
            <div style="width: 150px;font-size: 24px;font-family: Adobe Heiti Std;font-weight: normal;color: #666666;">
              开票内容
            </div>
            <div style="width: 554px;font-size: 24px;font-family: Adobe Heiti Std;font-weight: normal;color: #333333;">
              {{ item.productTitles?.split('@#@').join(' ') }}
            </div>
          </div>
          <div style="width: 704px;height: 2px;background: #DDDDDD;"></div>
          <div style="display: flex;height: 90px;align-items: center;">
            <div style="width: 150px;font-size: 24px;font-family: Adobe Heiti Std;font-weight: normal;color: #666666;">
              开票时间
            </div>
            <div style="font-size: 24px;font-family: Adobe Heiti Std;font-weight: normal;color: #333333;">
              {{ item.createDateTimeStr }}
            </div>
          </div>
          <div style="width: 704px;height: 2px;background: #DDDDDD;"></div>
          <div style="display: flex;height: 90px;align-items: center;">
            <div style="width: 150px;font-size: 24px;font-family: Adobe Heiti Std;font-weight: normal;color: #666666;">
              发票金额
            </div>
            <div style="font-size: 24px;font-family: Adobe Heiti Std;font-weight: normal;color: #333333;">
              {{ item.turnover }}
            </div>
          </div>
          <div style="width: 704px;height: 2px;background: #DDDDDD;"></div>
          <div style="display: flex;height: 90px;align-items: center;">
            <div style="width: 150px;font-size: 24px;font-family: Adobe Heiti Std;font-weight: normal;color: #666666;">
              开票状态
            </div>
            <div style="font-size: 24px;font-family: Adobe Heiti Std;font-weight: normal;color: #333333;">
              {{
                item.status === 1 ? '开票中' : item.status === 2 ?
                  '开票完成' : item.status === 3 ? '已下载' : '开票失败'
              }}
            </div>
          </div>
          <div style="width: 704px;height: 2px;background: #DDDDDD;"></div>
          <div style="display: flex;height: 90px;align-items: center;">
            <div style="width: 150px;font-size: 24px;font-family: Adobe Heiti Std;font-weight: normal;color: #666666;">
              操作
            </div>
            <div style="font-size: 24px;font-family: Adobe Heiti Std;font-weight: normal;color: #333333;">
              <div v-show="item.status === 2 || item.status === 3" class="no-1"
                   data-track-text="下载发票" :data-track-business-id="item.billCode"
                   @click="download()">下载
              </div>
              <div v-show="item.status !== 2 && item.status !== 3" class="no2-1"
                   data-track-text="不可下载发票" :data-track-business-id="item.billCode"
                   @click="">下载
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Billdetail",
  data() {
    return {
      item: {},
    }
  },
  created() {
    console.log(this.$route.params)
    this.item = this.$route.params
  },
  methods: {
    download() {
      if (!this.item.filePath) {
        this.$track('invoice_download_result', {result: 'failure', reason: 'missing_file', source: 'invoice_detail'})
        this.$message.warning("下载失败，请联系客服")
        return
      }
      const filePaths = this.item.filePath.split("@#@")
      this.$track('invoice_download_submit', {fileCount: filePaths.length, source: 'invoice_detail'})
      filePaths.forEach((item, index) => {
        fetch(item).then(res => res.blob().then(blob => {
          let a = document.createElement('a');
          let url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = this.item.billCode + "-发票（微思翻译wesitrans.com）.pdf";
          a.click();
          window.URL.revokeObjectURL(url);
          this.$track('invoice_download_result', {result: 'success', fileCount: 1, source: 'invoice_detail'})
        })).catch(() => {
          this.$track('invoice_download_result', {result: 'failure', reason: 'request_failed', fileCount: 1, source: 'invoice_detail'})
        });
      })

    },
    clickHandler(url) {
      this.$router.push(url)
    },
  }
}
</script>

<style lang="less" scoped>
.no-1 {
  cursor: pointer;
  padding: 5px 14px;
  width: 58px;
  height: 35px;
  background: #0c7dba;
  border: 1px solid #0c7dba;
  border-radius: 2px;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}

.no2,
.no2-1 {
  cursor: pointer;
  padding: 5px 14px;
  width: 86px;
  height: 35px;
  background: #edf2fc;
  border: 1px solid #edf2fc;
  border-radius: 2px;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #c0c4cc;
}
.timeButton {
  border-radius: 3px;
  cursor: pointer;
  white-space: nowrap;
  padding: 10px 20px;
  border: 0px solid #000;
  width: 94px;
  height: 45px;
  float: right;
  background-color: #efeded;
  font-size: 21px;
  font-weight: 400;
  font-family: Noto Sans S Chinese !important;
  color: #333333;
  display: flex;
  justify-content: center;
}

.timeButtonClick {
  border-radius: 3px;
  cursor: pointer;
  white-space: nowrap;
  padding: 10px 20px;
  border: 0px solid #000;
  width: 94px;
  height: 45px;
  float: right;
  background-color: #0c7dba;
  font-size: 18px;
  font-weight: 400;
  font-family: Noto Sans S Chinese !important;
  display: flex;
  justify-content: center;
  color: #ffffff;
}

.main-login-form {
  width: 704px;
  height: 1000px;
  background: #FFFFFF;

  .main-login-form-input {
    width: 704px;
    display: flex;
    flex-flow: column;
    justify-content: center;
  }
}

.user-main {
  min-width: 765px;
  width: 100%;
  background: #f5f5f5;
  display: flex;
  flex-flow: column;
  align-items: center;
  overflow-x: hidden;
}

.user-main-head {
  width: 100%;
  height: 88px;
  background: #E6E6E6;
  display: flex;
  align-items: center;
}

.user-main-head div {
  flex: 1;
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  text-align: center;
  margin-right: 60px;
}

@media (max-width: 768px) {
  .invoice-detail-page {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    align-items: stretch;
    overflow-x: hidden;
  }

  .detail-page-head {
    width: 100%;
    height: 56px;
    flex: 0 0 56px;
    background: #fff;
    border-bottom: 1px solid #e7edf3;
  }

  .detail-page-head img {
    width: 22px;
    height: 22px;
    margin-left: 14px !important;
    object-fit: contain;
    cursor: pointer;
  }

  .detail-page-head div {
    margin-right: 36px;
    font-size: 17px;
    font-weight: 600;
    color: #263341;
  }

  .detail-page-body {
    width: 100%;
    max-width: 100%;
    padding: 12px;
    align-items: flex-start;
  }

  .main-login-form {
    width: 100%;
    height: auto;
    min-height: calc(100vh - 182px);
    min-height: calc(100dvh - 182px);
    border: 1px solid #e1eaf2;
    border-radius: 12px;
    box-shadow: 0 5px 18px rgba(40, 74, 108, .06);

    .main-login-form-input {
      width: 100%;
    }
  }

  .main-login-form-input > div:nth-child(odd) {
    width: 100%;
    height: auto !important;
    min-height: 68px;
    padding: 14px 16px;
    display: grid !important;
    grid-template-columns: 78px minmax(0, 1fr);
    align-items: center;
    gap: 12px;
  }

  .main-login-form-input > div:nth-child(even) {
    width: calc(100% - 32px) !important;
    height: 1px !important;
    margin: 0 16px;
    background: #e8edf2 !important;
  }

  .main-login-form-input > div:nth-child(odd) > div:first-child {
    width: auto !important;
    min-width: 0;
    font-size: 13px !important;
    line-height: 1.45;
    color: #6b7784 !important;
  }

  .main-login-form-input > div:nth-child(odd) > div:nth-child(2) {
    width: auto !important;
    min-width: 0;
    overflow-wrap: anywhere;
    word-break: break-word;
    font-size: 14px !important;
    line-height: 1.55;
    color: #263341 !important;
  }

  .no-1,
  .no2-1 {
    width: auto;
    min-width: 72px;
    height: 36px;
    padding: 0 16px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    border-radius: 6px;
    white-space: nowrap;
  }
}
</style>
